import React from 'react';
import PropTypes from 'prop-types';
import Box from 'relements/build/esm/ui/box';
import Tabs from 'relements/build/esm/ui/tabs';
import Text from 'relements/build/esm/ui/text';

import CommonStore from '@src/stores/CommonStore';

import ScrollableLanguageTabs from './ScrollableLanguageTabs';

import styles from './LanguageTab.scss';

const getSupportedLanguages = (currentSelectedLanguage) => {
  const meta = CommonStore.getMetaTags();
  const { allLanguages, allHybridLanguages, domain } = meta;
  const { language_list: supportedLanguageList } = domain;

  const supportedLanguages = [];
  let supportedHybridLanugages = [];

  allLanguages.forEach((language) => {
    if (supportedLanguageList.includes(language.code)) {
      supportedLanguages.push({
        path: language.code,
        title: language.name,
      });
    }
  });

  if (allHybridLanguages?.[currentSelectedLanguage]?.length > 1) {
    supportedHybridLanugages = allHybridLanguages[currentSelectedLanguage].map(
      (lang) => ({
        script: lang.script,
        title: lang.native_name,
      })
    );
  }

  return { supportedLanguages, supportedHybridLanugages, allHybridLanguages };
};

const withClickScrollStyles = {
  overflow: 'hidden',
  position: 'relative',
};
function LanguageTab({
  currentBotSaysLanguage,
  currentHybridLanguage,
  onLanguageChange,
  errorLanguage,
  variant,
  withClickScroll,
}) {
  const {
    supportedLanguages,
    supportedHybridLanugages,
    allHybridLanguages,
  } = getSupportedLanguages(currentBotSaysLanguage);

  if (supportedLanguages.length < 2) return false;

  return (
    <Box
      padding={0}
      width="100%"
      display="block"
      style={withClickScroll ? withClickScrollStyles : {}}
    >
      {withClickScroll ? (
        <ScrollableLanguageTabs
          currentBotSaysLanguage={currentBotSaysLanguage}
          onLanguageChange={onLanguageChange}
          supportedLanguages={supportedLanguages}
          allHybridLanguages={allHybridLanguages}
          errorLanguages={errorLanguage}
        />
      ) : (
        <Tabs
          prefixClassName={styles.parentItems}
          value={currentBotSaysLanguage}
        >
          {supportedLanguages.map((tab) => (
            <Tabs.Item
              key={tab.path}
              value={tab.path}
              onClick={(botSaysLanguage) =>
                onLanguageChange(
                  botSaysLanguage,
                  allHybridLanguages[botSaysLanguage].length > 1
                    ? allHybridLanguages[botSaysLanguage][0]?.script
                    : botSaysLanguage,
                  allHybridLanguages[botSaysLanguage].length > 1
                    ? allHybridLanguages[botSaysLanguage][0]?.name
                    : tab.title
                )
              }
            >
              <div
                className={`${tab.path === errorLanguage && styles.hasError}`}
              >
                <Text variant="h4.semi-bold">{tab.title}</Text>
              </div>
            </Tabs.Item>
          ))}
        </Tabs>
      )}

      {Boolean(supportedHybridLanugages.length) && !withClickScroll && (
        <Tabs value={currentHybridLanguage.split('|')[0]}>
          {supportedHybridLanugages.map((tab) => (
            <Tabs.Item
              key={tab.script}
              value={tab.script}
              prefixClassName={`${variant === 'mobile' ? styles.expand : ''} ${
                styles.hybridItem
              }`}
              onClick={(hybridLanguage) =>
                onLanguageChange(
                  currentBotSaysLanguage,
                  hybridLanguage,
                  tab.title
                )
              }
            >
              <Text variant="h4.semi-bold">{tab.title}</Text>
            </Tabs.Item>
          ))}
        </Tabs>
      )}
    </Box>
  );
}

LanguageTab.propTypes = {
  currentBotSaysLanguage: PropTypes.string.isRequired,
  currentHybridLanguage: PropTypes.string.isRequired,
  onLanguageChange: PropTypes.func.isRequired,
  errorLanguage: PropTypes.string,
  variant: PropTypes.string,
  withClickScroll: PropTypes.bool,
};

LanguageTab.defaultProps = {
  errorLanguage: '',
  variant: 'mobile',
  withClickScroll: false,
};

export default LanguageTab;
